import { Address, PersonalInfo } from "@/components/sections/quote/types";

export const isAddressComplete = (address: Address): boolean => {
  return Object.values(address).every(value => value.trim() !== "");
};

export const isPersonalInfoComplete = (personalInfo: PersonalInfo): boolean => {
  return personalInfo.firstName.trim() !== "" && personalInfo.lastName.trim() !== "";
};

export const isContactInfoComplete = (personalInfo: PersonalInfo): boolean => {
  return personalInfo.email.trim() !== "" && personalInfo.phone.trim() !== "";
};

export const isStepComplete = (
  step: number,
  selectedType: string,
  address: Address,
  personalInfo: PersonalInfo
): boolean => {
  switch (step) {
    case 1:
      return !!selectedType;
    case 2:
      return isAddressComplete(address);
    case 3:
      return isPersonalInfoComplete(personalInfo);
    case 4:
      return isContactInfoComplete(personalInfo);
    default:
      return false;
  }
};